//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { gql } from 'graphql-tag'
import { Language, ContentType } from '@constants'

const JOBS = gql`
  query ($where: JobFilterInput) {
    jobs(where: $where, order: [{ startAt: DESC }]) {
      nodes {
        id
        externalId
        title
        slug
        company
        jobCategory
        startAt
        location
        abstract
      }
    }
  }
`

export default {
  name: 'JobList',
  scrollToTop: true,
  data() {
    return {
      jobs: [],
      showPlaceholder: true,
      placeholders: 4,
      ContentType,
      Language
    }
  },
  fetchOnServer: false,
  async fetch() {
    await this.refresh()
  },
  computed: {
    language() {
      return this.$store.get('language/locale') || 'en'
    },
    languageId() {
      return this.language === 'en' ? Language.ENGLISH : Language.DUTCH
    },
    currentBreakPoint() {
      return this.$store.get('app/currentBreakPoint') || 'md'
    }
  },
  watch: {
    languageId() {
      this.refresh()
    }
  },
  mounted() {
    this.setBreadcrumb({
      isShow: true,
      pageTitle: this.$t('jobs.jobs')
    })
    this.setFilters({
      isShow: false,
      showFilterTotal: false,
      header: this.$t('jobs.jobs'),
      isCardHeader: true
    })
  },
  methods: {
    async refresh() {
      this.showPlaceholder = true

      try {
        const { data } = await this.$apollo.query({
          query: JOBS,
          variables: {
            where: {
              languageId: {
                eq: this.languageId
              }
            }
          }
        })

        this.jobs = data.jobs.nodes
      } catch (error) {
        this.handleError(error)
      } finally {
        this.showPlaceholder = false
      }
    }
  }
}
